import Funnels from './Funnels';

const routes = [
  {
    path: 'list',
    label: 'All funnels',
    component: Funnels,
  },
];

export default routes;
